export const EVENT_BRANDING_UPLOAD_ERROR_MESSAGES = {
  MISSING_ETAG: "The branding upload response did not include an ETag",
  UNAVAILABLE: "Branding uploads are unavailable",
} as const;

export class EventBrandingUploadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EventBrandingUploadError";
  }
}
